import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../components/vxc_login';

@customElement('vxv-login')
export class TLoginView extends LitElement {

    // properties
    @property({ type: String, attribute: 'text-welcome'}) 	textWelcome: string  = "Welcome Back !"
    @property({ type: String, attribute: 'text-username'}) 	textUsername: string = "username"
    @property({ type: String, attribute: 'text-password'}) 	textPassword: string = "password"
    @property({ type: String, attribute: 'text-submit'}) 	textSubmit: string   = "Login"
    @property({ type: String, attribute: 'text-lostpwd'}) 	textLostPwd: string  = "" //"Forgot Password ?"
    @property({ type: String, attribute: 'text-register'}) 	textRegister: string = "" //"Sign Up"
    @property({ type: String, attribute: 'text-error'}) 	textError: string    = "Invalid credentials. Please try again."

  static styles = css`
    :host {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        z-index: 9999;
    }

    .container {
        width: 100%;
        height: 100%;
        margin: 0;
        display: grid;
        place-items: center;
        background: linear-gradient(to right, #12c2e9, #c471ed, #f64f59);
        xbackground: #318CFE;
        background-image: url('https://preprod.iamie.eu/botiful/botiful.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        font-family: 'Montserrat', sans-serif;
    }
            
    h1 {
        position: relative;
        font-size: 72px;
        color: white;
        line-height: 0;
    }

    .drop {
        position: absolute;
        height: 200px;
        width: 200px;
        background: #54ABFB;
        border-radius: 51% 49% 48% 52% / 62% 44% 56% 38%;
        opacity: 0.8;
        border: 2px solid #3d93ff;
    }

    .drop::before {
        content: "";
        position: absolute;
        height: 100%;
        width: 100%;
        background: #318CFE;
        border-radius: 51% 49% 48% 52% / 62% 44% 56% 38%;
        box-shadow: -20px 30px 16px #1B6CFB, -40px 60px 32px #1b6cfb, inset -6px 6px 10px #1B6CFB, inset 2px 6px 10px #1a74e5, inset 20px -20px 22px white, inset 40px -40px 44px #a8ceff;
    }

    .drop::after {
        content: "";
        position: absolute;
        height: 40px;
        width: 40px;
        background: #E6FDFB;
        border-radius: 44% 56% 46% 54% / 36% 50% 50% 64%;
        left: 130px;
        top: 40px;
        box-shadow: 16px 40px 0 -10px white;
        opacity: 0.8;
    }

    .drop2, .drop4 {
        border-radius: 46% 50% 39% 54% / 56% 57% 50% 50%;
    }

    .drop2::before, .dtop4::before {
        border-radius: 46% 50% 39% 54% / 56% 57% 50% 50%;
    }

    @keyframes float {
        0% {
            transform: translate(0vw, 0vw);
        }
        25% {
            transform: translate(95vw, 25vh);
        }
        50% {
            transform: translate(50vw, 95vh); 
        }
        75% {
            transform: translate(5vw, 55vh);
        }
        100% {
            transform: translate(0vw, 0vw);
        }
    }

    .drop {
        position: absolute;
        animation: float 90s infinite ease-in-out;
    }

    .drop2 {
        animation-delay: -20s;
    }

    .drop3 {
        animation-delay: -45s;
    }

    .drop4 {
        animation-delay: -65s;
    }


    .login-form {
        display: grid;
        place-items: center;
        position: relative;
        font-family: 'Poppins', sans-serif;
        padding: 0 2rem;
        margin: 5rem;
        background-color: rgba(255, 255, 255, 0.8);
        -webkit-border-radius: 20px;
        border-radius: 20px;
        border: 1px solid #318CFE;
        }
    `;


  render() {
    return html`
        <div class="container">
            <!--div class="drop drop1"></div>
            <div class="drop drop2"></div>
            <div class="drop drop3"></div>
            <div class="drop drop4"></div-->
            <div class="login-form">
                <vxc-login
                    text-welcome=${this.textWelcome || nothing}
                    text-username=${this.textUsername || nothing}
                    text-password=${this.textPassword || nothing}
                    text-submit=${this.textSubmit || nothing}
                    text-lostPwd=${this.textLostPwd || nothing}
                    text-register=${this.textRegister || nothing}
                    text-error=${this.textError || nothing}
                ></vxc-login>
            </div>        
        </div>
    `;
  }
}

// Type declarations
declare global {
  interface HTMLElementTagNameMap {
      'vxv-login': TLoginView;
  }
}